export default {
  SET_QUEUED_JOB_LOGS: function (state, payload) {
    state.queuedJobLogs = payload;
  }
}
